import { Trans, useTranslation } from 'react-i18next';

import { Select } from '@actual-app/components/select';
import type { SelectOption } from '@actual-app/components/select';

import { useGlobalPref } from '#hooks/useGlobalPref';
import { setI18NextLanguage } from '#i18n';

import { resolveProductFinanceLocale } from './product-i18n';
import type { ProductFinanceLocale } from './product-i18n';

export function ProductLanguageSettings() {
  const { t } = useTranslation();
  const [preference, setPreference] = useGlobalPref('language');
  const locale = resolveProductFinanceLocale(preference);
  const options: SelectOption[] = [
    ['es', t('Spanish')],
    ['en', t('English')],
  ];

  function changeLanguage(value: string) {
    const nextLocale: ProductFinanceLocale = value === 'es' ? 'es' : 'en';
    setPreference(nextLocale);
    setI18NextLanguage(nextLocale);
    document.documentElement.lang = nextLocale;
  }

  return (
    <label htmlFor="product-finance-language">
      <span style={{ display: 'block', marginBottom: 5 }}>
        <Trans>Select a language</Trans>
      </span>
      <Select
        id="product-finance-language"
        options={options}
        value={locale}
        onChange={changeLanguage}
      />
    </label>
  );
}
